import { GrafferPermissions } from "../../../application/domain/rbac/rbac";
import React from "react";
import { GroupPermissionAttached } from "../../../application/domain/group/grp_resource";
import { useAuthContext } from "../../../auth-state";
import { Auth } from "../../../application/domain/auth/auth";

const checkPermission = ({
  authState,
  target,
  requirePermissions,
}: {
  authState: Auth;
  target?: GroupPermissionAttached;
  requirePermissions?: GrafferPermissions;
}) => {
  if (!requirePermissions) {
    return true;
  }
  if (target) {
    if (authState.isAuthed) {
      if (
        authState.checkGroupPermission(target, [requirePermissions]) ||
        authState.isServiceProviderAccount()
      ) {
        return true;
      }
    }
    return false;
  } else if (authState.isAuthed) {
    if (authState.hasPermissions(requirePermissions)) {
      return true;
    }
  }
  return false;
};

export const useRBAC = () => {
  const authState = useAuthContext();

  const hasPermission = React.useCallback(
    ({
      target,
      requirePermissions,
    }: {
      target?: GroupPermissionAttached;
      requirePermissions?: GrafferPermissions;
    }): boolean => {
      return checkPermission({
        authState,
        target,
        requirePermissions,
      });
    },
    [],
  );

  return hasPermission;
};
